import { useEffect, useState } from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import colorConfigs from "../../../configs/colorConfigs";
import { DamageList } from "./DamageList";
import { AddDamage } from "./AddDamage";

const filterItems = [
    {
        id: 0,
        label: "Customer Name",
    },
]

type DamagesProps = {
    idNumber: any
}

export const Damages = ({
    idNumber
}: DamagesProps) => {
    const { themeStyles } = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [damageFilterValue, setDamageFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [openAddDamage, setOpenAddDamage] = useState<boolean>(false);
    const [refreshDamageList, setRefreshDamageList] = useState<boolean>(false);

    useEffect(() => {
        if (refreshDamageList) {
            setPaginationModel({
                page: 0,
                pageSize: 10,
            })
            setSearchValue("");
            setRefreshDamageList(false);
        }

                // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshDamageList])

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>

                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => setOpenAddDamage(true)}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Damage</span>
                        </button>
                    </div>
                </div>

                <div>
                    <DamageList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        damageFilterValue={damageFilterValue}
                        setDamageFilterValue={setDamageFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                        idNumber={idNumber}
                        setRefreshDamageList={setRefreshDamageList}
                    />
                </div>
            </div>
            {
                openAddDamage && (
                    <AddDamage
                        idNumber={idNumber}
                        openAddDamage={openAddDamage}
                        setOpenAddDamage={setOpenAddDamage}
                        setRefreshDamageList={setRefreshDamageList}
                    />
                )
            }
        </>

    )
}